import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyATurlihqfc2SWu_ugSyP9-NEuwgLXro3A",
  authDomain: "quit-gooning.firebaseapp.com",
  projectId: "quit-gooning",
  storageBucket: "quit-gooning.firebasestorage.app",
  messagingSenderId: "530967856265",
  appId: "1:530967856265:web:97ff3b6a41d6d9b064b258",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
